const findDiffIndex = (currentStr, newStr) => {
  const maxLength = Math.max(currentStr.length, newStr.length);
  for (let i = 0; i < maxLength; i++) {
    if (currentStr[i] !== newStr[i]) return i;
  }
  return -1;
};
const calculateDigitDirection = (currentChar, newChar) => {
  const currentDigit = parseInt(currentChar) || 0;
  const newDigit = parseInt(newChar) || 0;
  const upDistance = (newDigit - currentDigit + 10) % 10;
  const downDistance = (currentDigit - newDigit + 10) % 10;
  return upDistance <= downDistance ? 'up' : 'down';
};
const generateDigitSequence = (currentDigit, targetDigit, direction) => {
  if (direction === 'none' || !/\d/.test(currentDigit) || !/\d/.test(targetDigit)) {
    return [targetDigit];
  }
  const current = parseInt(currentDigit);
  const target = parseInt(targetDigit);
  const sequence = [];
  if (direction === 'up') {
    let digit = target;
    sequence.push(digit.toString());
    while (digit !== current && sequence.length < 5) {
      digit = (digit - 1 + 10) % 10;
      sequence.push(digit.toString());
    }
  } else {
    let digit = current;
    sequence.push(digit.toString());
    while (digit !== target && sequence.length < 5) {
      digit = (digit - 1 + 10) % 10;
      sequence.push(digit.toString());
    }
  }
  return sequence;
};
const shouldAnimateDigit = (changeStartIndex, index, currentChar, newChar) => {
  return changeStartIndex >= 0 && index >= changeStartIndex && currentChar !== newChar && /\d/.test(newChar) && /\d/.test(currentChar);
};

export { calculateDigitDirection, findDiffIndex, generateDigitSequence, shouldAnimateDigit };
